import React from 'react';
import { Dropdown } from 'antd';
import { CopyOutlined, DownOutlined } from '@ant-design/icons';
import toast from "react-hot-toast";
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../analytics';
import { marked } from 'marked';

function CopyToClipboardButton({ textToCopy, disabled }) {
  const { t } = useTranslation();

  const handleCopy = async (asPlainText = false) => {
    logEvent('Note', asPlainText ? 'CopyAsPlainText' : 'Copy');

    try {
      if (!asPlainText) {
        // Convert Markdown to HTML
        const htmlBody = marked.parse(textToCopy);
        const styledHtml = `
          <div style="font-size:14px; font-family:Arial,sans-serif; line-height:1.5;">
            ${htmlBody}
          </div>
        `;

        // Write both plain text and rich HTML to the clipboard
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
            'text/html': new Blob([styledHtml], { type: 'text/html' }),
          }),
        ]);
      } else {
        // Strip all markdown and HTML tags for plain text
        const plainText = textToCopy
          .replace(/<[^>]*>/g, '') // Remove HTML tags
          .replace(/[#*_~`]/g, '') // Remove markdown syntax
          .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // Convert markdown links to just text
          .replace(/\n{3,}/g, '\n\n') // Normalize multiple newlines
          .trim();

        // Write only plain text to the clipboard
        await navigator.clipboard.writeText(plainText);
      }

      toast.success(t('session_details.copy.success'));
    } catch (error) {
      console.error('Copy failed', error);
      toast.error(t('session_details.copy.error'));
    }
  };

  const items = [
    {
      key: 'plain-text',
      label: t('session_details.copy.as_plain_text'),
      onClick: () => handleCopy(true),
    },
  ];

  return (
    <Dropdown.Button
      icon={<DownOutlined />}
      disabled={disabled}
      onClick={() => handleCopy(false)}
      menu={{ items }}
      data-testid='copy-button'
    >
      <CopyOutlined /> {t('session_details.copy.label')}
    </Dropdown.Button>
  );
}

export default CopyToClipboardButton;